import React from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import PageHeader from 'components/pageHeader';
import DeviceApprovalRequests from 'components/UserDashboardV2/components/DeviceApprovalRequests';
import useResponsive from 'components/UserDashboardV2/hooks/useResponsive';

// Full page (sidebar stays visible via the normal Layout/route shell) for
// the "Device change request" header button on /user-management/staffs or
// /user-management/students.
const DeviceChangeRequestsPage = () => {
    const history = useHistory();
    const location = useLocation();
    const { isMobile } = useResponsive();

    const queryRole = new URLSearchParams(location.search).get("role");
    const isStaff = queryRole === "staff" || location?.state?.from === "staff" || location?.state?.role === "staff";

    const title = isStaff ? "Staff device change approval requests" : "Student device change approval requests";
    const basePath = location.pathname.startsWith('/user-management-v2') ? '/user-management-v2' : '/user-management';
    const backRoute = isStaff ? `${basePath}/staffs` : `${basePath}/students`;

    const bodyStyle = {
        margin: -20,
        padding: isMobile ? "20px 12px" : "40px 8px 20px 8px",
        width: "calc(100% + 30px)",
        height: "100vh",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    };

    return (
        <div style={bodyStyle}>
            <PageHeader
                title={title}
                onBackPress={() => history.push(backRoute)}
            />

            <div style={{ margin: "30px 0 0 0", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                <DeviceApprovalRequests isMobile={isMobile} role={isStaff ? "staff" : "student"} />
            </div>
        </div>
    );
};

export default DeviceChangeRequestsPage;
